import { MANIFEST_URL } from '../constants'
import type { ProjectManifest } from '../types/ProjectManifest'

export async function fetchManifest(): Promise<ProjectManifest> {
  const res = await fetch(MANIFEST_URL)
  if (!res.ok) {
    throw new Error('Fetching manifest failed. Status: ' + res.status)
  }

  return res.json()
}
